import { render, staticRenderFns } from "./wizard-hours.vue?vue&type=template&id=3a3484a2&scoped=true&lang=pug"
import script from "./wizard-hours.vue?vue&type=script&lang=ts"
export * from "./wizard-hours.vue?vue&type=script&lang=ts"
import style0 from "./wizard-hours.vue?vue&type=style&index=0&id=3a3484a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3484a2",
  null
  
)

export default component.exports